export default {
    indexEventCalendarSettings:         { method: 'get',    url: 'event_calendar_settings' },
    createEventCalendarSetting:         { method: 'post',   url: 'event_calendar_settings' },
    updateEventCalendarSetting:         { method: 'put',    url: 'event_calendar_settings/{id}' },
    destroyEventCalendarSetting:        { method: 'delete', url: 'event_calendar_settings/{id}' },
    updateCalendarSettingUploadLogo:    { method: 'post',   url: 'event_calendar_settings/upload/logo' },
}